














import { OrgRole } from '@/models';
import { OrgUser } from '@/models/orgStructure';
import Vue, { PropType } from 'vue';
import { orgRoleColors } from '../utils/unrulrColors';
export default Vue.extend({
  props: {
    user: Object as PropType<OrgUser>
  },

  computed: {
    role(): OrgRole {
      if (this.user.isAdmin) {
        return OrgRole.ADMIN;
      }

      if (this.user.isOrganizer) {
        return OrgRole.ORGANIZER;
      }

      return OrgRole.MEMBER;
    },

    borderColorClasses(): string[] {
      switch (this.role) {
        case OrgRole.ADMIN:
          return orgRoleColors.admin;
        case OrgRole.ORGANIZER:
          return orgRoleColors.organizer;
        case OrgRole.MEMBER:
          return orgRoleColors.member;
      }

      return [];
    },

    borderColor(): string {
      return this.borderColorClasses.join(' ');
    }
  }
});
